import {
  LucideBuilding,
  LucideHome,
  LucideSettings,
  LucideUsers,
  LucideBox,
  LucideBarChart,
  LucideClipboardList,
  LucideShoppingCart,
  LucideTrendingUp,
  BoxesIcon,
  ReceiptText,
  Layers,
  User2,
  LucideInfo,
} from "lucide-react";

export const ADMIN_MENU_CONFIG: any = {
  dashboard: {
    label: "Dashboard",
    path: "/admin/dashboard",
    icon: LucideHome,
  },
  tenants: {
    label: "Tenants",
    icon: LucideBuilding,
    subMenu: [
      {
        label: "Create Tenant",
        path: "/admin/tenant/create",
      },
      {
        label: "List of Tenants",
        path: "/admin/tenant/list",
      },
    ],
  },
  transactions: {
    label: "Transactions",
    icon: ReceiptText,
    subMenu: [
      {
        label: "Create Transaction",
        path: "/admin/transaction/create",
      },
      {
        label: "List of Transactions",
        path: "/admin/transaction/list",
      },
    ],
  },
  plans: {
    label: "Plans",
    icon: Layers,
    subMenu: [
      {
        label: "Create Plan",
        path: "/admin/plans/create",
      },
      {
        label: "List of Plans",
        path: "/admin/plans/list",
      },
    ],
  },
  reports: {
    label: "Reports",
    path: "/admin/reports",
    icon: LucideBarChart,
  },
  support: {
    label: "Support",
    path: "/admin/support",
    icon: LucideInfo,
  },
  settings: {
    label: "Settings",
    path: "/admin/settings",
    icon: LucideSettings,
  },
};

export const MENU_CONFIG: any = {
  dashboard: {
    label: "Dashboard",
    path: "/app/dashboard",
    icon: LucideHome,
    module: "dashboard",
    permission: "view",
  },
  inventory: {
    label: "Inventory",
    path: "/app/inventory",
    icon: LucideClipboardList,
    module: "inventory",
    permission: "view",
  },
  purchases: {
    label: "Purchases",
    icon: LucideShoppingCart,
    module: "purchases",
    subMenu: [
      {
        label: "Create a Purchase",
        path: "/app/purchase/create",
        permission: "create",
      },
      {
        label: "List of Purchases",
        path: "/app/purchase/list",
        permission: "view",
      },
    ],
  },
  sales: {
    label: "Sales",
    icon: LucideTrendingUp,
    module: "sales",
    subMenu: [
      {
        label: "Create a Sale",
        path: "/app/sale/create",
        permission: "create",
      },
      {
        label: "List of Sales",
        path: "/app/sale/list",
        permission: "view",
      },
    ],
  },
  adjustments: {
    label: "Adjustments",
    icon: BoxesIcon,
    module: "adjustments",
    subMenu: [
      {
        label: "Create an Adjustment",
        path: "/app/adjustment/create",
        permission: "create",
      },
      {
        label: "List of Adjustments",
        path: "/app/adjustment/list",
        permission: "view",
      },
    ],
  },
  products: {
    label: "Products",
    icon: LucideBox,
    module: "products",
    subMenu: [
      {
        label: "Create Product",
        path: "/app/product/create",
        permission: "create",
      },
      {
        label: "List of Products",
        path: "/app/product/list",
        permission: "view",
      },
    ],
  },
  category: {
    label: "Category/Sub Category",
    path: "/app/category",
    icon: LucideBox,
    module: "products",
    permission: "view",
  },
  users: {
    label: "Users",
    icon: LucideUsers,
    module: "users",
    subMenu: [
      {
        label: "Create a User",
        path: "/app/user/create",
        permission: "create",
      },
      {
        label: "List of Users",
        path: "/app/user/list",
        permission: "view",
      },
    ],
  },
  customers: {
    label: "Customers",
    path: "/app/customers",
    icon: LucideUsers,
    module: "sales",
    permission: "view",
  },
  suppliers: {
    label: "Suppliers",
    path: "/app/suppliers",
    icon: User2,
    module: "suppliers",
    permission: "view",
  },
  reports: {
    label: "Reports",
    path: "/app/reports",
    icon: LucideBarChart,
    module: "reports",
    permission: "view",
  },
  planUsage: {
    label: "Plan Usage",
    path: "/app/plan-usage",
    icon: Layers,
    adminOnly: true,
  },
  settings: {
    label: "Settings",
    path: "/app/settings",
    icon: LucideSettings,
  },
  support: {
    label: "Support",
    path: "/app/support",
    icon: LucideInfo,
  },
};
